const config = {
  API_URL: "https://menu.appac.io/api/react/",
};

export default config;
